module.exports = __webpack_public_path__ + "static/media/BB-logo-oed.f2f76ffa.png";